import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';

@Component({
    standalone: true,
    imports: [GridModule, NgClass],
    selector: 'steps-bar',
    templateUrl: './steps-bar.html',
    styleUrl: './steps-bar.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepsBarComponent implements OnChanges {
    @Input({ required: true })
    totalSteps!: number;

    @Input({ required: true })
    currentStep!: number;

    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    protected steps = [];

    ngOnChanges(changes: SimpleChanges) {
        let shouldDetectChanges = false;
        if (changes['totalSteps']) {
            this.steps = Array.from({ length: this.totalSteps });
            shouldDetectChanges = true;
        }
        if (changes['currentStep']) {
            shouldDetectChanges = true;
        }
        this.changeDetectorRef.detectChanges();
    }
}
